import OwnerMens from '../../../static/demo/menus.json'
import EmpMens from '../../../static/demo/menus_role_4.json'
import HostListView from '../../components/hostlist'
import CalendarDayView from '../../components/calendar_day_view'
import AlertPostponse from '../../components/alert_postponse'
import AlertSuccess from '../../components/alert_success'
import api from '../../services/service_calendar'

export default {
  components: {
    HostListView,
    CalendarDayView,
    AlertPostponse,
    AlertSuccess
  },
  data () {
    return {
      menus: [],
      notiDetail: []
    }
  },
  methods: {
    closePrograme () {
      if (confirm('กรุณากด alt + F4 เพื่อปิดโปรแกรม')) {
        window.open('', '_self', '')
        window.close()
      }
    },
    goTo (path) {
      if (path === '/pos') {
        $('#HostList').modal('show')
      } else if (path === '/alert') {
        $('#notiCalendar').modal('show')
      } else {
        this.$router.push(path)
      }
    },
    notiCalendar () {
      this.$store.commit('Loading')
      this.now_month = this.dateFormatDMY2(new Date()).split('-')
      let obj = {
        get_year: parseInt(this.now_month[0]),
        get_month: parseInt(this.now_month[1]),
        get_day: parseInt(this.now_month[2])
      }
      api.list(
        this.REST_URL,
        {
          headers: {
            'Access-Token': sessionStorage.token
          }
        },
        obj,
        result => {
          // console.log(result)
          if (result.response === 'success') {
            this.events = result.data
            // console.log(this.events)
            this.notiDetail = this.events.filter(e => e.status === 0).length > 99 ? '99+' : this.events.filter(e => e.status === 0).length.toString()
          }
          this.$store.commit('Loading')
        },
        error => {
          console.log('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
          this.$store.commit('Loading')
        }
      )
    }
  },
  mounted () {
    this.notiCalendar()
    const getUser = localStorage.getItem('user')
    if (getUser !== null) {
      const obj = JSON.parse(getUser)
      if (obj.role_id < 4) {
        this.menus = OwnerMens
      } else {
        this.menus = EmpMens
      }
    }
    this.$store.state.historyPage = ''
    this.checkUser()
    $('body').on('hidden.bs.modal', '.modal', function () {
      $(this).removeData('bs.modal')
    })
    $('#notiCalendar').on(
      'hide.bs.modal',
      function () {
        this.notiCalendar()
      // eslint-disable-next-line no-extra-bind
      }.bind(this)
    )
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/main_page.js